import { find } from 'lodash'
import { getHistory } from 'lib/history'
import { storeSearchPath, storeNewPath, storeComingSoonPath } from 'lib/urls'

const PRICE_SORTS = [
  {
    value: 'price-desc',
    label: 'Price: High to Low',
    params: {
      sort: 'price',
      order: 'desc',
    },
  },
  {
    value: 'price-asc',
    label: 'Price: Low to High',
    params: {
      sort: 'price',
      order: 'asc',
    },
  },
]

const REVIEW_SORTS = [
  {
    value: 'rating',
    label: 'Highest Rated',
    params: { sort: 'rating', order: 'desc' },
  },
  {
    value: 'reviews',
    label: 'Most Reviewed',
    params: { sort: 'reviews', order: 'desc' },
  },
]

export const BASE_SORT_OPTIONS = [
  {
    value: 'popular',
    label: 'Popular',
    params: { sort: 'popular' },
  },
  {
    value: 'newest',
    label: 'Newest',
    params: { sort: 'newest', order: 'desc' },
  },
  ...PRICE_SORTS,
  ...REVIEW_SORTS,
]

// still use popular key since default values will get set under that,
// but change the label to be "relevance" which is actually what we are showing
export const SEARCH_SORT_OPTIONS = [
  {
    value: 'popular',
    label: 'Relevance',
    params: {
      sort: 'popular',
    },
  },
  ...PRICE_SORTS,
  ...REVIEW_SORTS,
]

export const getSortOptions = () => {
  const location = getHistory().getCurrentLocation()
  if (location.pathname === storeSearchPath) {
    return SEARCH_SORT_OPTIONS
  }
  return BASE_SORT_OPTIONS
}

export const getActiveOption = (activeSortParams, sortOptions) => {
  const sort = activeSortParams?.sort
  const options = sortOptions || getSortOptions()
  const activeOption = find(options, (option) => option.params.sort === sort)
  return activeOption || sortOptions[0]
}
